import { config } from "@wovar/common";

const BASE_URL = `${config.apiUrl}/v1/ns`;

export const ENDPOINTS = {
  netsuite: {
    redirectToNetsuite: () => `${BASE_URL}/common/redirect-to-netsuite`,
  },
  receiveItems: {
    markAsReceived: (transactionId: string) =>
      `${BASE_URL}/recieve-items/transaction/${transactionId}/mark-received`,
  },
  labelPrinting: {
    print: () => `${BASE_URL}/label-printing/print`,
  },
} as const;
